// analyticsContext.js

import React, { createContext, useContext } from 'react';

const AnalyticsContext = createContext(null);

export const useAnalytics = () => useContext(AnalyticsContext);

export const AnalyticsProvider = ({ children }) => {
  // Assume user details are stored in state or context
  // const { userId, userEmail } = useAuth(); // useAuth is a custom hook to get user details

  const trackLinkClick = (url) => {
    // Your tracking code for link clicks using gtag
    window.gtag('event', 'click', {
      event_category: 'Link Click',
      event_label: url,
      // user_id: userId, // Include user ID in event data
      // user_email: userEmail, // Include user email in event data
    });
  };

  const trackButtonClick = (buttonName) => {
    // Your tracking code for button clicks using gtag
    window.gtag('event', 'click', {
      event_category: 'Button Click',
      event_label: buttonName,
      // user_id: userId, // Include user ID in event data
      // user_email: userEmail, // Include user email in event data
    });
  };

  const trackPageClick = (category, label) => {
    // Your tracking code for page clicks using gtag
    window.gtag('event', 'click', {
      event_category: category,
      event_label: label,
      // user_id: userId, // Include user ID in event data
      // user_email: userEmail, // Include user email in event data
    });
  };

  const trackTabClick = (tab) => {
    // Your tracking code for tab clicks using gtag
    window.gtag('event', 'click', {
      event_category: 'Tab Click',
      event_label: tab
    });
  };

  return (
    <AnalyticsContext.Provider
      value={{ trackLinkClick, trackButtonClick, trackPageClick, trackTabClick }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};
